module.exports = __webpack_public_path__ + "img/DSC_0013.94f850d6.jpg";